import type { FormEvent } from "react";

export const removeFormEvent = (e: FormEvent, cb: () => void) => {
  e.preventDefault();
  return cb();
};
